import { render, staticRenderFns } from "./QuickTipsIntegration.vue?vue&type=template&id=6c87487e&scoped=true&"
import script from "./QuickTipsIntegration.vue?vue&type=script&lang=js&"
export * from "./QuickTipsIntegration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c87487e",
  null
  
)

export default component.exports